<template>
  <div>
    <div class="form-group">
        <BroadcastTask :task="task"></BroadcastTask>
    </div>

    <div class="input-group mb-3">
        <div class="input-group-prepend">
            <span class="input-group-text">Broadcast To</span>
        </div>
        <select v-model="to" class="form-control">
            <option value="subscribers">Subscribers</option>
            <option value="admins">Bot Admins</option>
            <option value="chats">Bot Joined Channels/Groups</option>
            <option value="active-pm">Active Prime Members</option>
            <option value="expired-pm">Expired Prime Members</option>
        </select>
    </div>

    <button class="btn btn-success" @click="startBroadcast">Broadcast</button>
    
    <div class="my-3" v-if="start">
        <h2>Broadcasting to {{total_subscribers}} subscribers</h2>
        <div class="progress my-3">
            <div
                class="progress-bar progress-bar-striped bg-info progress-bar-animated"
                :style="{width:percentage+'%'}"
            >Sent to {{progress}}</div>
        </div>

        <p>Completes in : {{time.toFixed(2)}} seconds</p>

        <div class="row">
            <div class="w-50">
                <div class="jumbotron border border-success m-3 text-center rounded">
                    <h1 class="text-success">{{success}}</h1>
                    <h4 class="text-success">Success</h4>
                </div>
            </div>
            <div class="w-50">
                <div class="jumbotron border border-danger m-3 text-center rounded">
                    <h1 class="text-danger">{{fails}}</h1>
                    <h4 class="text-danger">Failed</h4>
                </div>
            </div>
        </div>
    </div>

  </div>
</template>

<script>
import TelegramService from "@/services/TelegramService";
import ApiService from "@/services/ApiService";
import Library from "@/services/Library";


import BroadcastTask from "@/components/BroadcastTask.vue";



export default {
    name: 'Broadcast',
    components:{
        BroadcastTask,
    },
    props: {
        token: String,
        user: Object,
        admins: Array,
        chatsJoined: Array,
        activePM: Array,
        expiredPM: Array
    },
    data: () => {
        return{
            task: {
                "method": null,
                "data": null,
                "error": false
            },
            to: "subscribers",
            start:false,
            subscribers: [],
            total_subscribers:0,
            time:0,
            progress:0,
            success:0,
            fails:0,
            percentage:0
        }
    },
    methods:{
        getSubscribersRecursive(user, token, lastEvaluatedKey){
            return new Promise((resolve) => {
                ApiService.getSubscribers(user, token, lastEvaluatedKey)
                .then(
                    function(result) {
                    this.subscribers = this.subscribers.concat(result.Items);
                    if(result.LastEvaluatedKey){
                        resolve(this.getSubscribersRecursive(user, token, result.LastEvaluatedKey));  
                    }
                    else{
                        resolve(result.Items);
                    }
                    }.bind(this)
                )
                .catch(
                    function(response) {
                    this.$dialog.alert(response.description);
                    }.bind(this)
                );
            });
        },
        // getFile(file){
        //     var reader = new FileReader();
        //     var vm = this;
        //     reader.onload = (e) => {
        //         vm.image = e.target.result;
        //     };
        //     reader.readAsDataURL(file);
        // },
        // onFileChange(e){
        //     var files = e.target.files || e.dataTransfer.files;
        //     this.file = files[0];
        //     console.log(this.file)
        //     // this.getFile(files[0]);
        // },

        async startBroadcast() {
            if(!this.validateInput())
            {   
                return false;
            }

            if(this.to=="subscribers")
            {
                let subscribers = []
                this.subscribers = []
                this.getSubscribersRecursive(this.user, this.token, null)
                .then(function(){
                    this.subscribers.forEach(function(subscriber) {
                    if(subscriber.id > 0)
                        subscribers.push(subscriber.id)
                    });
                this.broadcastMessage(subscribers)
                }.bind(this))
                .catch(
                function(response) {
                    this.$dialog.alert(response.description);
                }.bind(this)
                );
            }
            else if(this.to=="admins")
            {
                this.broadcastMessage(this.admins)
            }
            else if(this.to=="chats")
            {
                this.broadcastMessage(this.chatsJoined)
            }
            else if(this.to=="active-pm")
            {
                let active_pm = []
                this.activePM.forEach(function(pm) {
                    active_pm.push(pm.id)
                });
                this.broadcastMessage(active_pm)
            }
            else if(this.to=="expired-pm")
            { 
                let expired_pm = []
                this.expiredPM.forEach(function(pm) {
                    expired_pm.push(pm.id)
                });
                this.broadcastMessage(expired_pm)
            }
        },
        resetValues(){
            this.total_subscribers = 0
            this.time = 0
            this.success = 0
            this.fails = 0
            this.progress = 0
            this.percentage = 0
        },
        async broadcastMessage(to_list){
            let delay = 0.034;  //second, 34ms
            this.resetValues()
            this.start = true
            this.total_subscribers = to_list.length
            this.time = to_list.length * delay
            let data = JSON.parse(JSON.stringify(this.task.data));
            if(data.reply_markup == null){
                delete data['reply_markup'];
            }
            let method = this.task.method;
            // There is no method called 'SendQuiz'
            if(this.task.method == 'SendQuiz'){method = 'SendPoll'}

            for (let index = 0; index < to_list.length; index++) {
                data['chat_id'] = to_list[index];
                TelegramService.send(this.token, data, method)
                .then(function(){
                    this.success++;
                }.bind(this))
                .catch(function(error) {
                    console.log(error);
                    this.fails++;
                }.bind(this))
                .finally(function() {
                    this.progress++;
                    this.time -= delay;
                    if (this.time < 0){
                        this.time = 0
                    }
                    this.percentage = ((this.progress+1)/to_list.length)*100;
                }.bind(this));
                await this.sleep(delay*1000);
            }    
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        validateInput(){
            this.task.error = false;
            var IGNORE = ["reply_markup", "caption", "error", "to"]
            let data = JSON.parse(JSON.stringify(this.task.data));
            if ("reply_markup" in data && data.reply_markup != null) {
                if (!Library.verify_reply_markup(data.reply_markup)) {
                    console.log("Reply markup field verification failed")
                    this.task.error = true;
                    this.$dialog.alert(
                        "Fill all Button fields."
                    );
                    return false;
                }
            }
            if(Library.check_if_empty_field(data, IGNORE) == false){
                this.task.error = true;
                this.$dialog.alert("Please fill all the fields.");
                return false;
            }
            return true;
        }
    }
}
</script>

<style>

</style>